import WMTSTileGrid from 'ol/tilegrid/WMTS';
import { getTopLeft } from 'ol/extent';
import { get as getProjection, Projection, addProjection } from 'ol/proj';
import proj4 from 'proj4';

proj4.defs(
  'EPSG:25832',
  '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
);
var p25832 = new Projection({
  code: 'EPSG:25832',
  extent: [120000, 5661139.2, 958860.8, 6500000],
  units: 'm',
});
addProjection(p25832);

// Samme, men til WFS fra datafordeler
// proj4.defs('urn:ogc:def:crs:EPSG::25832','+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
var px25832 = new Projection({
  code: 'urn:ogc:def:crs:EPSG::25832',
  extent: [120000, 5661139.2, 958860.8, 6500000],
  units: 'm',
});
addProjection(px25832);
// Grid til WMTS
export const projection = getProjection('EPSG:25832');
var projectionExtent = projection.getExtent();
var resolutions = [
  1638.4,
  819.2,
  409.6,
  204.8,
  102.4,
  51.2,
  25.6,
  12.8,
  6.4,
  3.2,
  1.6,
  0.8,
  0.4,
  0.2,
];
export const matrixIds = [
  'L00',
  'L01',
  'L02',
  'L03',
  'L04',
  'L05',
  'L06',
  'L07',
  'L08',
  'L09',
  'L10',
  'L11',
  'L12',
  'L13',
  'L14',
];

var origin = getTopLeft(projectionExtent);
export const tileGrid = new WMTSTileGrid({
  origin,
  resolutions,
  matrixIds,
});
